export default __webpack_public_path__ + "static/media/men_banner.01418214.jpg";